import * as React from 'react';
import { observer } from 'mobx-react';

import BaseSwiper from '@src/components/swiper/base-swiper';
import Link from '@src/components/link';
import BackgroundImage from '@src/components/background-image';
import aos from '@src/utils/aos';
const styles = require('../../index.less');

const Feature = ({ store }) => {
  store.use();
  return (
    <React.Fragment>
      <div className="main-layer-49" {...aos.FADE_UP()} />
      <div className="main-group-22" data-name="五图" {...aos.FADE_UP()}>
        <div className="main-group-23" data-name="轮播图">
          {store.featureImgList?.length > 0 && (
            <div className="main-group-23-swiper">
              <BaseSwiper store={store.featureBaseSwiperStore}>
                {store.featureImgList.map((item, index) => {
                  return (
                    <div className="main-layer-50" key={index}>
                      <BackgroundImage src={item?.url} className="main-layer-50-content" />
                      {/*<BackgroundImage src={require('../../images/swiper-demo.png')} className="main-layer-50-content" />*/}
                    </div>
                  );
                })}
              </BaseSwiper>
            </div>
          )}
        </div>

        <Link
          className="main-layer-53"
          onClick={() => {
            store.featureBaseSwiperStore.goNext();
          }}
        />
        <Link
          className="main-layer-54"
          onClick={() => {
            store.featureBaseSwiperStore.goPrev();
          }}
        />
        <div className="main-group-24" id="main-group-24" data-name="页码" />
      </div>

      <div className="main-layer-61" {...aos.FADE_UP()} />
    </React.Fragment>
  );
};

export default observer(Feature);
